// 9看料 —— 单页站静态展示数据（配图均为暖色杂志编辑风示意图）

export const navTopics = [
  { id: "variety", label: "综艺" },
  { id: "idol", label: "选秀" },
  { id: "emotion", label: "情感" },
  { id: "workplace", label: "职场" },
  { id: "live", label: "直播" },
  { id: "sales", label: "带货" },
  { id: "esports", label: "电竞" },
  { id: "trend", label: "热搜" },
];

export const quickTopics = ["今晚高能", "九图连击", "截图打脸", "深夜反转", "粉丝比心"];

export const heroItems = [
  {
    image:
      "https://readdy.ai/api/search-image?query=warm%20editorial%20still%20life%20of%20a%20smartphone%20lying%20on%20cream%20paper%20beside%20a%20fan%20of%20printed%20screenshot%20sheets%20and%20a%20small%203x3%20photo%20grid%2C%20nine%20abstract%20lifestyle%20thumbnails%20in%20amber%20coral%20and%20stone%20tones%2C%20cozy%20soft%20window%20light%2C%20shallow%20depth%2C%20editorial%20media%20magazine%20aesthetic%2C%20high%20detail%2C%20no%20legible%20text%2C%20no%20watermark&width=900&height=680&seq=hero-lead-2601&orientation=landscape",
    title: "今晚压轴九宫格：九张图串起一条完整现场时间线",
    summary:
      "从开场自拍、同框对视到后台散场，九宫格按时间轴排好，把关键转折一图看清，标注顺序看图更省力。",
    tag: "九宫格热榜",
    views: "28.6w",
    time: "刚刚",
    alert: true,
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=artful%20stack%20of%20printed%20collage%20grids%20in%20coral%20and%20amber%20tones%20on%20a%20warm%20beige%20desk%2C%20rounded%20smartphone%20screen%20glowing%20on%20top%20showing%20a%20blurred%20colorful%20grid%2C%20editorial%20media%20mood%2C%20cinematic%20soft%20shadows%2C%20warm%20harmonious%20palette%2C%20no%20legible%20text%2C%20no%20watermark&width=520&height=640&seq=hero-card-2602&orientation=portrait",
    title: "同框图九连拍，谁主动谁回避一眼能看穿",
    summary: "机位几乎没动，情绪却层层递进，逐张圈出微表情变化。",
    tag: "九图吃瓜",
    views: "12.1w",
    time: "8分钟前",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20editorial%20shot%20of%20a%20hand%20holding%20a%20phone%20showing%20a%20neat%203x3%20grid%20of%20blurred%20warm%20lifestyle%20photos%2C%20soft%20coral%20backdrop%2C%20magazine%20lighting%2C%20muted%20warm%20tones%2C%20cinematic%2C%20no%20legible%20text%2C%20no%20watermark&width=520&height=640&seq=hero-card-2603&orientation=portrait",
    title: "隔空互动回应合集：一句文案拆出三层意思",
    summary: "把同一条回应配上不同时间点的三组截图，围观话术里的留白。",
    tag: "截图合集",
    views: "9.4w",
    time: "21分钟前",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=top%20view%20of%20an%20open%20magazine%20spread%20with%20mounted%20square%20photo%20grids%20and%20warm%20tape%2C%20amber%20and%20rose%20color%20palette%2C%20editorial%20document%20collage%2C%20soft%20daylight%2C%20no%20legible%20text%2C%20no%20watermark&width=520&height=640&seq=hero-card-2604&orientation=portrait",
    title: "多图预警：深夜连发九图，评论区秒变破案现场",
    summary: "九张图里藏了三条时间戳，网友按图索骥拼出完整顺序。",
    tag: "多图预警",
    views: "7.8w",
    time: "35分钟前",
    alert: true,
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=editorial%20scene%20of%20scattered%20polaroid%20style%20photo%20tiles%20and%20a%20phone%20on%20a%20rust%20colored%20surface%2C%20warm%20evening%20light%2C%20amber%20accent%2C%20magazine%20layout%2C%20soft%20film%20grain%2C%20no%20legible%20text%2C%20no%20watermark&width=520&height=640&seq=hero-card-2605&orientation=portrait",
    title: "带节奏截图被反向锤：原图时间线全在这",
    summary: "收齐同角度三组截图，逐条对照，谁在移花接木一目了然。",
    tag: "图片爆料",
    views: "6.2w",
    time: "1小时前",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=wide%20editorial%20view%20of%20a%20warm%20cream%20desk%20with%20a%20smartphone%20grid%2C%20several%20stacked%20screenshot%20sheets%20and%20amber%20paper%20notes%2C%20coral%20and%20honey%20tones%2C%20magazine%20photo%20style%2C%20soft%20natural%20light%2C%20no%20legible%20text%2C%20no%20watermark&width=900&height=520&seq=hero-feat-2606&orientation=landscape",
    title: "图文猛料专区：让每张截图自己开口说话",
    summary: "图片爆料不只放图，更按场景拆好顺序、圈好重点，让你不翻几十页也能抓住关键帧。",
    tag: "专区导读",
    views: "31.9w",
    time: "置顶",
  },
];

export const nineCollections = [
  {
    image:
      "https://readdy.ai/api/search-image?query=symmetrical%203%20by%203%20grid%20collage%20of%20nine%20warm%20abstract%20photo%20cells%20with%20thin%20white%20borders%2C%20coral%20amber%20and%20cream%20palette%2C%20editorial%20mood%20board%2C%20soft%20even%20light%2C%20no%20legible%20text%2C%20high%20detail%2C%20no%20watermark&width=800&height=600&seq=nine-grid-a-2611&orientation=landscape",
    title: "颁奖礼后台九图：获奖瞬间与表情管理全记录",
    summary: "把同场的高光、泪目与表情管理按机位排成九宫格，顺序即剧情。",
    tag: "九图吃瓜",
    views: "18.2w",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=grid%20collage%20of%20nine%20sepia%20toned%20abstract%20retro%20photo%20cells%20arranged%20symmetrically%2C%20warm%20golden%20amber%20grading%2C%20vintage%20editorial%20style%2C%20soft%20grain%2C%20even%20layout%2C%20no%20legible%20text%2C%20no%20watermark&width=800&height=600&seq=nine-grid-b-2612&orientation=landscape",
    title: "时隔多年的同框再聚：九张对比图讲述时间差",
    summary: "左侧旧照、右侧近照，九格并排放一起，变化一目了然。",
    tag: "九宫格爆料",
    views: "15.7w",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=three%20by%20three%20grid%20collage%20of%20nine%20rose%20and%20coral%20toned%20abstract%20stage%20light%20photo%20cells%2C%20soft%20bokeh%2C%20editorial%20night%20scene%20palette%2C%20symmetrical%20composition%2C%20no%20legible%20text%2C%20no%20watermark&width=800&height=600&seq=nine-grid-c-2613&orientation=landscape",
    title: "舞台同框九连拍：谁退谁进，走位里全是态度",
    summary: "圈出每一格的站位变化，围观现场默契如何一步步崩掉。",
    tag: "九图吃瓜",
    views: "11.3w",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=neat%20grid%20collage%20of%20nine%20warm%20cream%20and%20honey%20abstract%20still%20photo%20cells%20with%20thin%20margins%2C%20minimal%20editorial%20mood%20board%2C%20soft%20diffused%20daylight%2C%20harmonious%20tones%2C%20no%20legible%20text%2C%20no%20watermark&width=800&height=600&seq=nine-grid-d-2614&orientation=landscape",
    title: "同款穿搭撞车现场：九张对比图全网大搜集",
    summary: "把同时间段的同款造型按人排开，撞得有多巧一眼见分晓。",
    tag: "图片爆料",
    views: "9.8w",
  },
];

export const shotGallery = [
  {
    image:
      "https://readdy.ai/api/search-image?query=stacked%20smartphone%20screenshot%20mockup%20sheets%20with%20blurred%20warm%20chat%20bubbles%20and%20image%20tiles%2C%20coral%20accent%20backdrop%2C%20editorial%20flat%20lay%2C%20soft%20shadows%2C%20no%20legible%20text%2C%20no%20watermark&width=520&height=640&seq=shot-gallery-a-2621&orientation=portrait",
    title: "一段私聊的完整截图链：从寒暄到摊牌",
    summary: "按时间接好每一条，红圈标出态度转折的那几句。",
    meta: "聊天记录",
    time: "2小时前",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=editorial%20flat%20lay%20of%20a%20phone%20with%20blurred%20social%20comment%20screens%20and%20warm%20amber%20paper%20notes%2C%20soft%20coral%20background%2C%20magazine%20layout%2C%20cinematic%20light%2C%20no%20legible%20text%2C%20no%20watermark&width=520&height=640&seq=shot-gallery-b-2622&orientation=portrait",
    title: "评论区逐条复盘：神回复与反转并排",
    summary: "热评按点赞数排开，谁在带风向、谁在破案全标出来。",
    meta: "评论区",
    time: "3小时前",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20editorial%20image%20of%20stacked%20screenshot%20printouts%20with%20blurred%20timeline%20rows%20in%20warm%20tones%2C%20honey%20and%20rose%20accent%2C%20soft%20top%20light%2C%20no%20legible%20text%2C%20no%20watermark&width=520&height=640&seq=shot-gallery-c-2623&orientation=portrait",
    title: "官宣文案的前后版本：一字之差定舆论方向",
    summary: "同一句话的三版草稿放在一起，措辞变化耐人寻味。",
    meta: "官宣对比",
    time: "5小时前",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=artful%20layout%20of%20a%20phone%20screen%20with%20blurred%20live%20stream%20frames%20beside%20warm%20tape%20and%20amber%20cards%2C%20editorial%20night%20media%20aesthetic%2C%20soft%20glow%2C%20no%20legible%20text%2C%20no%20watermark&width=520&height=640&seq=shot-gallery-d-2624&orientation=portrait",
    title: "直播间截图考古：从开播到下播的完整走位",
    summary: "按时间抽帧排开，把一场直播里的名场面一网打尽。",
    meta: "直播截图",
    time: "6小时前",
  },
];

export const featureMag = [
  {
    image:
      "https://readdy.ai/api/search-image?query=wide%20editorial%20photo%20essay%20arrangement%20of%20nine%20warm%20abstract%20grid%20cells%20spread%20across%20cream%20paper%20with%20amber%20notes%2C%20coral%20and%20honey%20tones%2C%20magazine%20spread%2C%20soft%20cinematic%20lighting%2C%20no%20legible%20text%2C%20no%20watermark&width=1200&height=760&seq=feat-mag-a-2631&orientation=landscape",
    kicker: "本周吃瓜专题",
    title: "一张九宫格，如何讲完整场戏",
    summary:
      "我们把“看图吃瓜”拆成三步：先看九格顺序，再找每格里的关键帧，最后比对时间戳。9看料 九宫格爆料图集把流程讲清楚，多图预警也能一眼看懂重点在哪里。",
  },
  {
    image:
      "https://readdy.ai/api/search-image?query=editorial%20photo%20essay%20of%20scattered%20polaroid%20shots%20and%20screenshot%20sheets%20on%20warm%20terracotta%20paper%2C%20rose%20and%20amber%20grading%2C%20magazine%20spread%20style%2C%20soft%20film%20grain%2C%20no%20legible%20text%2C%20no%20watermark&width=1200&height=760&seq=feat-mag-b-2632&orientation=landscape",
    kicker: "截图考古方法论",
    title: "为什么同一件事，图一多就反转",
    summary:
      "图片爆料最难的是只给片段。这篇 9看料 截图合集手把手教你收齐不同视角，再按顺序把关键截图拼回真相，九图吃瓜也要看全貌。",
  },
];

export const feedItems = [
  {
    no: "01",
    title: "同框对视合集三连发，评论区却在吵谁先转头",
    summary: "连配三组九宫格截图，红圈逐张标注视线落点与表情切换，围观一个眼神引发的连锁反应。",
    tag: "九图吃瓜",
    time: "10分钟前",
  },
  {
    no: "02",
    title: "深夜文案被截图考古，配图时间线比正文更精彩",
    summary: "同一句话对上前几天配图的时间戳，前后口径对不上，图片爆料最怕的就是细节打架。",
    tag: "图片爆料",
    time: "32分钟前",
  },
  {
    no: "03",
    title: "带货返场翻车现场：九张连拍完整记录补救过程",
    summary: "从尬演、救场到道歉一气排成九宫格，多图预警把每一步都标得明明白白。",
    tag: "多图预警",
    time: "1小时前",
  },
  {
    no: "04",
    title: "隔空喊话再发酵，本尊评论区空降两条考古截图",
    summary: "当事人亲自下场贴图回应，截图合集里第一次出现“本人认证”字样。",
    tag: "截图合集",
    time: "2小时前",
  },
  {
    no: "05",
    title: "选秀台下九图：举灯牌的那只手究竟是谁",
    summary: "九宫格爆料按秒抽帧，把镜头一晃而过的瞬间逐格放大，等你来当福尔摩斯。",
    tag: "九宫格爆料",
    time: "3小时前",
  },
];

export const topicIndex = [
  { label: "综艺高能", desc: "同框、对视、走位连拍", count: "128 集", num: "01" },
  { label: "选秀考古", desc: "台下反应与成团瞬间", count: "96 集", num: "02" },
  { label: "情感拉扯", desc: "私聊、评论与深夜文案", count: "204 集", num: "03" },
  { label: "职场修罗场", desc: "甩锅、背刺与带节奏截图", count: "87 集", num: "04" },
  { label: "直播名场面", desc: "开播到下播的逐帧复盘", count: "143 集", num: "05" },
  { label: "带货翻车", desc: "现场补救与话术对比", count: "75 集", num: "06" },
  { label: "电竞心态战", desc: "交流、红温与赛点截图", count: "69 集", num: "07" },
  { label: "热搜考古", desc: "词条从生到灭的全记录", count: "188 集", num: "08" },
];

export const guideSteps = [
  {
    num: "01",
    title: "认准九宫格顺序",
    desc: "9看料 九宫格爆料图集按现场时间轴排图，从左到右、从上到下就是一整条故事线。",
  },
  {
    num: "02",
    title: "留意多图预警角标",
    desc: "标注「多图预警」的九图吃瓜帖子，通常配有完整截图合集，看完全部图片再下结论更稳。",
  },
  {
    num: "03",
    title: "对比关键截图",
    desc: "图片爆料里最怕断章取义，把不同视角的关键截图放一起看，谁在带节奏自然清楚。",
  },
];

export const faqs = [
  {
    q: "「九宫格」和「九图」有什么区别？",
    a: "两者在 9看料 里指向同一种内容形态：一次发布 9 张配图，通常按时间或事件顺序排列，用来讲清一件完整的事。九宫格更强调九张图的排版与节奏，九图吃瓜则偏重事件解读。",
  },
  {
    q: "看到「多图预警」是什么意思？",
    a: "表示这条图文猛料不止首图，正文里还有一整套关键截图合集。建议按顺序把图片全部看完，再结合标题理解重点，避免只看一两张被带偏。",
  },
  {
    q: "图文猛料里的截图可信吗？",
    a: "9看料 只做娱乐信息的整理与可视化呈现，截图来自公开传播内容且会标注视角与时间。是否采信请自行判断，本站不做事实裁决，也提醒大家理性看图、友善发言。",
  },
  {
    q: "浏览九宫格爆料会泄露我自己的信息吗？",
    a: "不会。本站是纯浏览的图文集合页，你无需注册、登录或提交任何资料，打开页面即可直接观看九宫格、截图合集与九图吃瓜内容。",
  },
  {
    q: "喜欢某个题材，如何更快找到同类九图吃瓜？",
    a: "首页下方的题材目录已按综艺、选秀、情感、直播等分好类。点击对应板块标签即可锁定该题材下的九宫格爆料与截图合集，省去逐条翻找的时间。",
  },
];

export const trustList = [
  {
    icon: "ri-eye-line",
    title: "浏览即用，零门槛",
    desc: "无需注册登录，打开页面就能看图，九宫格、截图合集随手看。",
  },
  {
    icon: "ri-question-line",
    title: "只整理，不裁决",
    desc: "图片爆料与九图吃瓜仅作娱乐信息呈现，立场与事实判断交给你。",
  },
  {
    icon: "ri-chat-3-line",
    title: "理性围观提示",
    desc: "多图预警图集信息量大，建议看完再评论，友善发言从自己做起。",
  },
];